export default __webpack_public_path__ + "img/3e794e79c9835824bde27d90119bdbca.jpg";